import {useEffect, useState} from 'react';

export type Hash = {
	/** current hash */
	current: string;
	/** old hash */
	old: string;
};

export const useHash = () => {
	const [hash, setHash] = useState<Hash>({
		current: window.location.hash,
		old: window.location.hash,
	});

	useEffect(() => {
		const listener = (event: Event) => {
			setHash((currentState) => ({
				current: window.location.hash,
				old: currentState.current,
			}));
		};

		window.addEventListener('hashchange', listener);

		return () => {
			window.removeEventListener('hashchange', listener);
		};
	}, []);

	return hash;
};

export default useHash;
